// extracted by css-extract-rspack-plugin
export default {"root":"_31l2E18qj174o42TAWX04x","check":"_3snp1qN-qOAdqTTrohOfWl","time":"_1_xqB4uF4K7nFx7ENyKiBd"};